export default function configTrustedResources($sceDelegateProvider) {
  'ngInject';
  let whiteList = $sceDelegateProvider.resourceUrlWhitelist() || [];

  $sceDelegateProvider.resourceUrlWhitelist(whiteList.concat([
    // Trust PrintOS CDN images
    'https://cdn.printos.com/**',
  ]));
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/trust-images.config.js